/**
 * Справочник интересов (`GET /dictionaries/interests`).
 * Публичный, кэшируется HTTP-кэшем по ETag (CC §12.2 п. 6).
 */
import { useQuery } from '@tanstack/react-query'

import { api, unwrap } from '@shared/api/client'
import type { Interest } from '@shared/api/types'

export function useInterests(): Interest[] {
  const { data } = useQuery({
    queryKey: ['dictionaries', 'interests'],
    queryFn: async () => unwrap(await api.GET('/dictionaries/interests')).items,
    staleTime: 60 * 60_000,
  })

  return data ?? []
}
